import { useQuery } from "@tanstack/react-query";
import { fetchBnbGasPrice } from "api/coin-api";
export var useGasData = function () {
    return useQuery({
        queryKey: ["gasPrice", "bnb"],
        queryFn: fetchBnbGasPrice,
        refetchInterval: 60000,
    });
};
